import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';

@Component({
    selector: 'ca-external-login-settings',
    templateUrl: './external-login-settings.component.html',
    styleUrls: ['./external-login-settings.component.scss'],
    standalone: false
})
export class ExternalLoginSettingsComponent implements OnInit {
  externalLoginSettingsForm: FormGroup;
  externalLoginSettingDtos: ConfigurationSettingsDto[] = [];

  private readonly settingKeySamlLoginEndPoint = 'ExternalLogin.SamlLoginEndPoint';
  private readonly settingKeySamlLoginEnabled = 'ExternalLogin.SamlLoginEnabled';
  private readonly settingKeySamlDefaultRedirectEndPoint =
    'ExternalLogin.SamlDefaultRedirectEndPoint';

  acceptFileExtensions: string[] = ['.cert'];
  selectedCertFile: File | null = null;

  constructor(
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private fb: FormBuilder,
    private localizationService: LocalizationService
  ) {
    this.externalLoginSettingsForm = fb.group({
      samlLoginEndPoint: [this.config.getSetting(this.settingKeySamlLoginEndPoint)],
      samlLoginEnabled: [
        this.config.getSetting(this.settingKeySamlLoginEnabled) === 'true' ? true : false,
      ],
      samlDefaultRedirectEndPoint: [
        this.config.getSetting(this.settingKeySamlDefaultRedirectEndPoint),
      ],
    });
  }

  ngOnInit(): void {}

  saveExternalLoginSettings() {
    this.externalLoginSettingDtos = [];

    this.externalLoginSettingDtos.push({
      settingName: this.settingKeySamlLoginEndPoint,
      settingValue: this.externalLoginSettingsForm.get('samlLoginEndPoint').value.toString(),
    });

    this.externalLoginSettingDtos.push({
      settingName: this.settingKeySamlLoginEnabled,
      settingValue: this.externalLoginSettingsForm.get('samlLoginEnabled').value.toString(),
    });

    this.externalLoginSettingDtos.push({
      settingName: this.settingKeySamlDefaultRedirectEndPoint,
      settingValue: this.externalLoginSettingsForm
        .get('samlDefaultRedirectEndPoint')
        .value.toString(),
    });

    this.settingService.saveSetting(this.externalLoginSettingDtos).subscribe({
      next: () => {
        this.toastr.success(
          this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
        );
        if (this.selectedCertFile) {
          this.settingService.uploadSamlCertificate(this.selectedCertFile).subscribe({
            next: () => {
              setTimeout(() => {
                this.toastr.success(
                  this.localizationService.instant('Settings::CertificateImported')
                );
              }, 100);

              this.selectedCertFile = null;
            },
            error: () => {
              setTimeout(() => {
                this.toastr.error(
                  this.localizationService.instant('Settings::CertificateImportFailed')
                );
              }, 100);
            },
          });
        }
      },
    });
  }

  onImportFormClick(e: MouseEvent) {
    const el = document.getElementById('samlCertSelector') as HTMLElement;
    el.click();
  }

  onImportForm(files: FileList) {
    if (!files || files.length === 0) {
      return;
    }

    const file = files.item(0);
    if (!file) {
      return;
    }

    const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    if (!this.acceptFileExtensions.includes(extension)) {
      this.toastr.error(this.localizationService.instant('Settings::InvalidFormFile'));
      return;
    }

    this.selectedCertFile = file;
  }
}
